import Axios from '@/http'
export default {
  // 关注用户
  getFollowUsers() {
    return new Promise((resolve, reject) => {
      Axios.post('userAttenDev/userAttenDev').then((res) => {
        resolve(res)
      })
    })
  },

  // 设备数量统计
  provinceCityCal() {
    return new Promise((resolve, reject) => {
      Axios.post('homePage/provinceCityCal').then((res) => {
        resolve(res)
      })
    })
  }
}
